//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmFooter from '@/components/cmFooter.vue'

export default {
  name: 'group',
  components:{
    cmFooter
  },
  data () {
    return {
      code:'',
      info: {
        nickname:'未登录',
        head:'/static/images/head.png',
        other_title:'',
        address:'',
      },
      order:{
        today_amount:0.00,
        total_amount:0.00,
        total_rebate:0.00,
        today_rebate:0.00,
        today_order:0
      },
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getInfo();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  
  },
  methods:{
    // getCode(){
    //   var local = window.location.href
    //   var appid = 'wx319f232455d7da71' 
    //   this.code = this.getUrlCode().code 
    //   if (this.code == null || this.code === '') {
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    //   } else {
    //     this.login();
    //   }
    // },
    // getUrlCode() {
    //   var url = location.search
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //       var str = url.substr(1)
    //       var strs = str.split("&")
    //       for(var i = 0; i < strs.length; i++) {
    //           theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
    //       }
    //   }
    //   return theRequest
    // },
    // login(){
    //     this.$api.login({code:this.code}).then((res)=>{
    //       if(res){
    //         console.log(res);
    //         this.$func.setLocal('token',res.data.token);
    //         this.getInfo();
    //       }
    //     })  
    // },
    getInfo(){
      this.$api.getInfo({}).then((res)=>{
        if(res){
          if(!Number(res.data.cid)){
              this.$router.push({path:'/login'})
              return false;
          }
          this.info = res.data;
          this.groupRebate();
        }
      })
    },
    groupRebate(){
      this.$api.groupRebate({}).then((res)=>{
        if(res){
          this.order = res.data.order;
        }
      })
    },
    out(){
      this.$func.confirm('确认退出账号？','温馨提示',()=>{
        this.$api.out({}).then((res)=>{
          if(res){
            // this.$func.setSession('token','');
            // this.$func.setLocal('token','');
            this.$router.push({path:'/login'})

          }
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/group.vue